import React from 'react';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Welcome from '../components/Welcome';
import WhyChoose from '../components/WhyChoose';
import ServicesDetailed from '../components/ServicesDetailed';
import CTABand from '../components/CTABand';
import Reviews from '../components/Reviews';
import LocalContractor from '../components/LocalContractor';
import Footer from '../components/Footer';
import FloatingCTAs from '../components/FloatingCTAs';
import BrandMarquee from '../components/BrandMarquee';

export default function HomePage() {
  // Roofing manufacturer brands - Using actual uploaded logos
  const roofingBrands = [
    {
      name: 'CertainTeed',
      logo: 'https://customer-assets.emergentagent.com/job_elite-roofing-3/artifacts/i7hg7bnm_Certainteed%20Logo.png'
    },
    {
      name: 'GAF',
      logo: 'https://customer-assets.emergentagent.com/job_elite-roofing-3/artifacts/vy9tf7go_GAF_logo.svg.png'
    },
    {
      name: 'IKO',
      logo: 'https://customer-assets.emergentagent.com/job_elite-roofing-3/artifacts/l5f6vwtp_Iko%20Logo.png'
    },
    {
      name: 'Tamko',
      logo: 'https://customer-assets.emergentagent.com/job_elite-roofing-3/artifacts/d9kf9i0f_Tamko-logo.png.webp'
    }
  ];

  // Paint manufacturer brands - Using actual uploaded logos
  const paintBrands = [
    {
      name: 'Sherwin-Williams',
      logo: 'https://customer-assets.emergentagent.com/job_elite-roofing-3/artifacts/4kcslp4q_Sherwin%20WIlliams%20logo.png'
    },
    {
      name: 'Benjamin Moore',
      logo: 'https://customer-assets.emergentagent.com/job_elite-roofing-3/artifacts/nbi5sm7f_Benjamin%20Moore%20Logo.png'
    },
    {
      name: 'PPG',
      logo: 'https://customer-assets.emergentagent.com/job_elite-roofing-3/artifacts/oi1354jc_PPG.png'
    }
  ];

  return (
    <>
      <TopBar />
      <Navbar />
      <Hero />
      <Welcome />
      <WhyChoose />
      <ServicesDetailed />
      <BrandMarquee brands={roofingBrands} title="Trusted Roofing Partners" />
      <CTABand />
      <BrandMarquee brands={paintBrands} title="Premium Paint Partners" />
      <Reviews />
      <LocalContractor />
      <Footer />
      <FloatingCTAs />
    </>
  );
}
